<template>
  <div style="width: 100vw;height: 100vh;overflow: auto;background-color: #F2F5FA;">
    <!-- 首页 -->
    <home-page v-if="step == 0" @changeStep="changeStep"></home-page>
    <!-- 引导步骤 -->
    <step-one
        v-if="step > 0 && step < setpList.length + 1"
        :step="step"
        :stepNum="setpList.length"
        :stepContent="setpList[step-1]"
        @changeStep="changeStep"
        ></step-one>
    <!-- 引导结束 -->
    <finish-page v-if="step == setpList.length+1"></finish-page>
    <!-- 悬浮框 -->
    <guideMenu v-show="![0,setpList.length+1].includes(step)"></guideMenu>
  </div>
</template>

<script>
import homePage from './components/homePage.vue';
import stepOne from './components/stepOne.vue';
import finishPage from './components/finishPage.vue';
import guideMenu from './components/guideMenu.vue';
import head from '@/mixins/head';

export default {
    mixins: [ head ],
    components: { homePage, stepOne, finishPage, guideMenu },
    data() {
        return {
            currentCompany: 1,
            setpList: [
                {
                    title: '抖音配置',
                    content: '【管理端】-【客服聊天对接】-【抖音对接】-【已对接账号】-【客服配置】中，配置成自己的账号。',
                    img: require('@/assets/img/guide/example/example-dy.png'),
                    tip: '客户关注该抖音号并发消息后，消息会进入到所设置的客服账号的聊天中'
                },
                {
                    title: '微信公众号配置',
                    content: '【管理端】-【客服聊天对接】-【微信对接】-【已对接账号】-【客服配置】中，配置成自己的账号。',
                    img: require('@/assets/img/guide/example/example-wxgzh.png'),
                    tip: '客户关注该公众号并发消息后，消息会进入到所设置的客服账号的聊天中'
                },
                {
                    title: '微信小程序配置',
                    content: '【管理端】-【客服聊天对接】-【微信小程序对接】-【已对接账号】-【客服配置】中，配置成自己的账号',
                    img: require('@/assets/img/guide/example/example-wxxcx.png'),
                    tip: '客户关注该小程序并发消息后，消息会进入到所设置的客服账号的聊天中'
                },
                {
                    title: 'WEB端',
                    content: '【管理端】-【访客端设置】配置成自己的账号',
                    img: require('@/assets/img/guide/example/example-web.png'),
                    tip: '客户关注该小程序并发消息后，消息会进入到所设置的客服账号的聊天中'
                },
                {
                    title: 'H5端',
                    content: '【管理端】-【访客端设置】配置成自己的账号',
                    img: require('@/assets/img/guide/example/example-web.png'),
                    tip: '客户关注该小程序并发消息后，消息会进入到所设置的客服账号的聊天中'
                },
                // {
                //     title: '微博配置',
                //     content: '【管理端】-【客服聊天对接】-【微博对接】-【已对接账号】-【客服配置】中，配置成自己的账号。',
                //     img: require('@/assets/img/guide/example/example-clue.png'),
                //     tip: '客户关注该微博号并发消息后，消息会进入到所设置的客服账号的聊天中'
                // },
                {
                    title: '线索配置',
                    content: '【管理端】-【线索设置】-【编辑】中，配置成自己的账号。',
                    img: require('@/assets/img/guide/example/example-clue.png'),
                    tip: '客户进行线索表单的填写后，则电话会自动拨打到该员工的手机号中'
                }
            ]
        };
    },
    computed: {
        step() {
            return Number(this.$route.params.step);
        }
    },
    methods: {
        changeStep(info) {
            let step, company;
            if (typeof info === 'object') {
                step = info.step;
                company = info.company;
            } else {
                step = info;
                company = this.$route.params.company;
            }
            this.$router.push({ name: 'guideHome', params: { step, company } });
        }
    }
};
</script>

<style  lang="scss" scoped>

</style>
